export default __webpack_public_path__ + "static/media/torres.1c9b8e06.jpg";